import type { PropsWithChildren } from 'react'
import { LosseLayout } from '@ubo/losse-sjedel'
import Footer from './Footer'
import Header from './Header/Header'

export default function Layout({ children }: PropsWithChildren<{}>) {
  return (
    <LosseLayout>
      <Header />
      <main className="pt-6">{children}</main>
      <Footer />
    </LosseLayout>
  )
}
